<div mat-dialog-title>
  <div class="flex flex-row space-x-2 items-center">
    <div>Конфликты копирования</div>
    <mat-icon
      i18n-matTooltip
      matTooltip="При копировании материалов из истории раскроя в текущий заказ произошли конфликты.
       Решите их чтобы завершить копирование. Если выбрано Заменить, то панель или материал берется из истории раскроя"
      >help_outline</mat-icon
    >
  </div>
  <button mat-icon-button [mat-dialog-close]="false" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content>
  <mat-list>
    <ng-container *ngFor="let item of conflictedItems">
      <div class="flex flex-col items-start">
        <mat-list-item>
          <div class="flex flex-row space-x-4 justify-between items-center">
            <p i18n class="text-truncate max-w-80" i18n-matTooltip [matTooltip]="item.material.name">{{
              item.material.name
            }}</p>
            <mat-radio-group class="pl-8" (change)="materialRadioGroupChange(item.material, $event)">
              <mat-radio-button i18n [value]="1">Заменить</mat-radio-button>
              <mat-radio-button class="pl-4" i18n [value]="2">Объединить</mat-radio-button>
            </mat-radio-group>
          </div>
        </mat-list-item>
        <mat-list class="pl-3">
          <mat-list-item *ngFor="let panel of item.panels">
            <div class="flex flex-row space-x-4 justify-between items-center">
              <p i18n class="text-truncate">Позиция {{ panel.position }}</p>
              <mat-checkbox i18n (change)="replacePanelChange($event, panel, item.material)" [checked]="true"
                >Заменить</mat-checkbox
              >
            </div>
          </mat-list-item>
        </mat-list>
      </div>
    </ng-container>
  </mat-list>
</div>
<div mat-dialog-actions>
  <button i18n mat-raised-button class="mat-accent" (click)="saveAndClose()" [disabled]="newMaterials.length === 0"
    >ОК</button
  >
  <button i18n mat-button mat-dialog-close>ОТМЕНА</button>
</div>
